"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _keyBy2 = _interopRequireDefault(require("lodash/keyBy"));

var _PulseApiHelper = _interopRequireDefault(require("./PulseApiHelper"));

var _NotificationsConfigFetcher = _interopRequireDefault(require("./NotificationsConfigFetcher"));

var Constants = _interopRequireWildcard(require("../constants/Constants"));

var NotificationsSelectors = _interopRequireWildcard(require("../store/reducers/NotificationReducer"));

var _Reminders = _interopRequireDefault(require("../actions/Reminders"));

var types = _interopRequireWildcard(require("../store/actions/actionTypes"));

var NotificationsPollService =
/*#__PURE__*/
function () {
  function NotificationsPollService() {
    (0, _classCallCheck2.default)(this, NotificationsPollService);
  }

  (0, _createClass2.default)(NotificationsPollService, [{
    key: "fetchNotificationsData",

    /*
    * fetchNotificationsData() is to make the periodic polling call to ANS API
    */
    value: function fetchNotificationsData() {
      var _this = this;

      this.getNotifications(store);
      setInterval(function () {
        return _this.getNotifications(store);
      }, Constants.NOTIFICATION_POLL_INTERVAL_TIME);
    }
    /*
    * getNotifications(store) is to make the call to ANS API
    * to fetch the notifications
    */

  }, {
    key: "getNotifications",
    value: function () {
      var _getNotifications = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(store) {
        var pulseApiHelper, notificationConfigFetcher, data;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pulseApiHelper = new _PulseApiHelper.default(), notificationConfigFetcher = new _NotificationsConfigFetcher.default();
                _context.next = 3;
                return notificationConfigFetcher.fetchNotificationsData(store);

              case 3:
                data = _context.sent;
                this.parseNotificationData(data, pulseApiHelper, store);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNotifications(_x) {
        return _getNotifications.apply(this, arguments);
      }

      return getNotifications;
    }()
    /*
    * parseNotificationData(data, pulseApiHelper, store) is to parse the response
    * received from ANS API for notifications and act upon the type of notification
    * accordingly
    */

  }, {
    key: "parseNotificationData",
    value: function () {
      var _parseNotificationData = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(data, pulseApiHelper, store) {
        var notifications, serverTimestamp, parsedNotifications, newNotifications, reminders, updatedNotifications, latestNotificationTimestamp, i, notification, notificationsById, _notificationsById;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                notifications = (0, _get2.default)(data, 'notifications');
                serverTimestamp = (0, _get2.default)(data, 'server-timestamp');
                notifications = (0, _get2.default)(notifications, 'notification', []);
                parsedNotifications = [];
                notifications.forEach(
                /*#__PURE__*/
                function () {
                  var _ref = (0, _asyncToGenerator2.default)(
                  /*#__PURE__*/
                  _regenerator.default.mark(function _callee2(notification) {
                    var parsedNotification;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(notification.type == 'com.adobe.ans.system.v1')) {
                              _context2.next = 4;
                              break;
                            }

                            _context2.next = 3;
                            return store.dispatch({
                              type: types.MARK_ALL_NOTIFICATION_AS_READ
                            });

                          case 3:
                            return _context2.abrupt("return");

                          case 4:
                            parsedNotification = pulseApiHelper.createPulseMessageObject(notification);

                            if (parsedNotification !== null) {
                              parsedNotifications.push(parsedNotification);
                            }

                          case 6:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x5) {
                    return _ref.apply(this, arguments);
                  };
                }()); //Notification poll would receive data in all these cases
                //1. An update happened to a notification (mark as read/payload change, metadata change?)
                //2. Could be a new notification
                //3. Could be a reminder getting fired
                //4. System generated nottification

                newNotifications = [], reminders = [], updatedNotifications = [];
                latestNotificationTimestamp = NotificationsSelectors.getLatestNotificationTimestamp(store.getState());

                for (i = 0; i < parsedNotifications.length; ++i) {
                  notification = parsedNotifications[i]; //the below conditions filter the incoming notifications into 3 categories
                  //1. Brand new notifications
                  //2. Updates to exisiting notifications
                  //3. Reminders on the exisiting notifications
                  //4. System generated notifications
                  //simplest case is the new notifications

                  if (notification.createdTimestamp > latestNotificationTimestamp) {
                    newNotifications.push(notification);
                  } else {
                    //if reminderTime key exists in the notification, this update could be
                    //1. A general update
                    //2. Reminder fire
                    if ('reminderTime' in notification) {
                      if (notification.reminderTime > serverTimestamp) {
                        //if the reminderTime is still greater than the time on the server, it means the update is a general update (like mark as read)
                        updatedNotifications.push(notification);
                      } else {
                        reminders.push(notification);
                      }
                    } else {
                      //No reminders have been set on this notification, so it is a general update
                      updatedNotifications.push(notification);
                    }
                  }
                }

                if (!(newNotifications.length > 0)) {
                  _context3.next = 12;
                  break;
                }

                //dispatch action to the store
                notificationsById = (0, _keyBy2.default)(newNotifications, function (notification) {
                  return notification.id;
                });
                _context3.next = 12;
                return store.dispatch({
                  type: types.LONG_POLL_NOTIFICATIONS_FETCHED,
                  notificationsById: notificationsById
                });

              case 12:
                if (!(updatedNotifications.length > 0)) {
                  _context3.next = 16;
                  break;
                }

                _notificationsById = (0, _keyBy2.default)(updatedNotifications, function (notification) {
                  return notification.id;
                });
                _context3.next = 16;
                return store.dispatch({
                  type: types.NOTIFICATIONS_UPDATED,
                  notificationsById: _notificationsById
                });

              case 16:
                if (!(reminders.length > 0)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 19;
                return store.dispatch({
                  type: types.REMINDERS_FETCHED,
                  reminders: reminders
                });

              case 19:
                _context3.next = 21;
                return _Reminders.default.removeReminders(reminders);

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function parseNotificationData(_x2, _x3, _x4) {
        return _parseNotificationData.apply(this, arguments);
      }

      return parseNotificationData;
    }()
  }]);
  return NotificationsPollService;
}();

var _default = new NotificationsPollService();

exports.default = _default;